import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Trad } from '../../interfaces/trad.interface';
import { TradMeddelande } from '../../interfaces/tradMeddelande.interface';
import { formatDate } from '@angular/common';

@Injectable()
export class TradService {
  constructor(
    private http: HttpClient,
    @Inject('API_URL') protected apiUrl: string,
    @Inject(LOCALE_ID) protected localeId: string) {
  }

  public get(instance: string, id: string): Observable<Trad> {
    return this.http.get<Trad>(`${this.apiUrl}${instance}/tradar/get/${id}`);
  }

  public createMessage(instance: string, id: string, text: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}${instance}/tradar/createMessage/${id}`, { text });
  }
}
